
export default {
  name: 'CtaSection',
  props: {
    blockOptions: {
      type: Object
    }
  }
}
